// 产品名称
// export const PHOTO_HOME = '相册'
// export const FRAME = '相框'
// export const HARD_FRAME = '硬盘相框'

export const PRODUCT_NAME = {
  PHOTO_HOME: "相册",
  FRAME: "相框",
  HARD_FRAME: "硬盘相框",
};



// WEBPACK FOOTER //
// ./src/common/constant.js